import styled from 'styled-components'

export const ModalContent = styled.div`
    width: 100%;
    max-height: 60vh;
    overflow: scroll;

    tr {
        cursor: pointer;

        td {
            transition: background-color 0.2s ease-in-out;
        }

        &:hover {
            td {
                background-color: #f7f7f7;
            }
        }

        &.selected {
            td {
                background-color: #dae7f1;
            }
        }
    }

    &.overflow-visible {
        overflow: visible;
    }

    &.overflow-auto {
        overflow: auto;
    }

    .search-row {
        padding-top: 5px;
        width: 100%;
        margin: 0;
        position: sticky;
        top: 0;
        background-color: #fff;
        z-index: 10;
    }
`
